module.exports = __webpack_public_path__ + "assets/img/btn-info-d939f64b.png";